import { Component, OnInit, ApplicationRef  } from '@angular/core';
import { UserService } from './_services';
import {Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, Event as RouterEvent,} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  title = 'ONE_Home_Frontend';
  showFooter = false;
  loading =false;
  onRouteActivate() {
    // Show footer after a small delay to ensure content is loaded
    setTimeout(() => {
      this.showFooter = true;
    }, 100); // Adjust delay if needed
  }
constructor(private _US: UserService, private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      }

      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        // Smooth delay to allow DOM/content to render
        setTimeout(() => {
          this.loading = false;
        }, 1000); // adjust to your liking
      }
    });
  }

  
  ngOnInit(): void {
    // this.getSasToken();
    // let oneHomeCurrentUser = this.isStringJSON(localStorage.getItem("oneHomeCurrentUser")!);
    // if (oneHomeCurrentUser) {
    //   localStorage.removeItem('oneHomeCurrentUser');
    // } else {
      let decryptedData = localStorage.getItem("oneHomeCurrentUser") ? this._US.getDecryptData(localStorage.getItem("oneHomeCurrentUser")) : null;
      // let decryptedData = localStorage.getItem("oneHomeCurrentUser")! ? this._US.getDecryptData(localStorage.getItem("oneHomeCurrentUser")!) : null;
      const allReadyLoggedIn = decryptedData;
      if (allReadyLoggedIn && allReadyLoggedIn.token) {
        this._US.updateUserAuth(true, allReadyLoggedIn);
      }
    // }
    this.router.events.subscribe(event => {
      if (event instanceof NavigationError) {
        // Handle the navigation error, redirect to home or any specific page
        this.router.navigate(['/']); // Redirect to the home page
      }
    });
  }

  isStringJSON(str: string): boolean {
    try {
      JSON.parse(str);
      return true;
    } catch (error) {
      return false;
    }
  };

  getSasToken() {
  //   this._US.getSasToken().subscribe(
  //     (data: any) => {
  //       if (data.meta.status) {
  //         let newData = this._US.getDecryptData(data.data);
  //         this._US.changeSastoken(newData);
  //       }
  //     }
  //   )
  }

}
